<div class="container-fluid pt-2 app">
  <div class="row">
    <div class="col pl-0 pr-0">
      <div class="card pl-2 pr-2 mt-2 border-0">

        <!-- Header Section -->
        <div class="row ml-0 mr-0 mb-2 p-2 rounded border-0 bg-secondary">
          <div class="col-xl-4 col-lg-4 col-md-5 col">
            <h3 class="h3 mb-0 pl-1 align-middle text-truncate float-left text-dark lh-40">
              {{ templateId ? ('forms.builder.edit' | trans) : ('forms.builder.create' | trans) }}
            </h3>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 d-none d-md-block" *ngIf="templateId">
            <div class="lh-33 align-middle">
              <span class="version-badge">{{ 'forms.version' | trans }} {{ templateVersion }}</span>
              <span [class]="'status-badge status-' + templateStatus + ' ml-1'">{{ templateStatus | uppercase }}</span>
            </div>
          </div>
          <div class="col-auto ml-auto">
            <button type="button" (click)="openPreviewModal()" class="btn">
              <h6 class="btn-text lh-20 pl-3 pr-3">
                {{ 'forms.builder.previewForm' | trans }}
                <span class="material-icons btn-icon align-middle lh-25 f-18 ml-1 icon-color">
                  visibility
                </span>
              </h6>
            </button>
          </div>
        </div>

        <!-- Read-only Warning -->
        <div *ngIf="isReadOnly" class="alert alert-secondary mb-2" role="alert">
          <div class="d-flex align-items-center">
            <span class="material-icons mr-2 f-20">warning</span>
            <div class="flex-grow-1">
              <strong>{{ templateStatus === 'archived' ? ('forms.builder.archived.title' | trans) :
                ('forms.builder.readonly.title' | trans) }}</strong>
              <p class="mb-0 f-15">{{ templateStatus === 'archived' ? ('forms.builder.archived.message' | trans) :
                ('forms.builder.readonly.message' | trans) }}</p>
            </div>
            <button *ngIf="templateStatus === 'published'" type="button" (click)="createDraftFromPublished()"
              [disabled]="isCreatingDraft" class="btn ml-2">
              <h6 class="btn-text lh-20 pl-3 pr-3">
                {{ isCreatingDraft ? ('forms.builder.creating' | trans) : ('forms.builder.createDraft' | trans) }}
              </h6>
            </button>
          </div>
        </div>

        <!-- Form Name & Description -->
        <div class="row ml-0 mr-0 mb-2">
          <div class="col-xl-6 col-lg-6 col-md-12 p-0 pr-md-2 mb-2">
            <div class="form-group mb-0">
              <label class="font-weight-light f-15 mb-0" for="formName">
                {{ 'forms.builder.name.label' | trans }}
              </label>
              <input type="text" id="formName" [(ngModel)]="templateName"
                placeholder="{{ 'forms.builder.name.placeholder' | trans }}" class="form-control h-40 mb-0"
                [disabled]="isReadOnly" required />
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 p-0 pl-md-2 mb-2">
            <div class="form-group mb-0">
              <label class="font-weight-light f-15 mb-0" for="formDescription">
                {{ 'forms.builder.description.label' | trans }}
              </label>
              <input type="text" id="formDescription" [(ngModel)]="templateDescription"
                placeholder="{{ 'forms.builder.description.placeholder' | trans }}" class="form-control h-40 mb-0"
                [disabled]="isReadOnly" />
            </div>
          </div>
        </div>

        <!-- Builder Layout -->
        <div class="row ml-0 mr-0">
          <!-- Field Palette -->
          <div class="col-xl-2 col-lg-3 col-md-3 p-0 pr-2 d-none d-md-block">
            <div class="card p-2 mb-3 bg-secondary">
              <h6 class="mb-2 font-weight-light lh-25 text-dark">{{ 'forms.builder.palette.title' | trans }}</h6>
              <button *ngFor="let type of fieldTypes" type="button" (click)="addFieldToCurrentTab(type)"
                class="btn w-100 mb-2 pt-0 pb-0 h-40" [disabled]="isReadOnly"
                [matTooltip]="'forms.fieldtype.' + type + '.desc' | trans" matTooltipPosition="right"
                matTooltipShowDelay="500">
                <h6 class="align-middle mb-0 lh-40 w-100 text-left btn-text float-left">
                  {{ getFieldTypeLabel(type) }}
                  <span class="material-icons btn-icon align-middle lh-40 f-18 mr-15 icon-color float-right">
                    add
                  </span>
                </h6>
              </button>
            </div>
          </div>

          <!-- Tab Editor -->
          <div class="col-xl-10 col-lg-9 col-md-9 p-0 pr-2">
            <div class="card pl-2 pr-2 mb-3 bg-secondary" style="padding-top:2px;">

              <!-- Tab Management -->
              <div class="mb-2">
                <div class="d-flex align-items-center justify-content-between ">
                  <h6 class="mb-0 font-weight-light lh-25 text-dark">{{ 'forms.builder.tabs.title' | trans }}</h6>
                  <button type="button" (click)="addTab()" class="btn-empty border-0 p-0 rounded-circle"
                    [disabled]="isReadOnly" [matTooltip]="'forms.builder.tabs.add' | trans" matTooltipPosition="above"
                    matTooltipShowDelay="500">
                    <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                      add
                    </span>
                  </button>
                </div>

                <div class="d-flex flex-wrap">
                  <div *ngFor="let tab of tabs; let i = index" [ngClass]="{ 'active-tab': currentTabIndex === i }"
                    (click)="selectTab(i)" class="tab-item card p-1 mb-1 mr-1 cursor-pointer">
                    <div class="d-flex align-items-center tab-title-wrapper">
                      <ng-container *ngIf="isTabEditing(tab); else tabTitleView">
                        <input type="text" [(ngModel)]="editingTabTitle"
                          class="form-control lh-25 form-control-sm h-auto p-1 tab-title-input"
                          (click)="$event.stopPropagation()" (keydown.enter)="saveTabTitle(tab, $event)"
                          (blur)="saveTabTitle(tab)" [disabled]="isReadOnly" />
                        <button type="button" (click)="saveTabTitle(tab, $event)"
                          class="btn-empty border-0 p-0 ml-1 tab-action" [disabled]="isReadOnly" matTooltip="Save title"
                          matTooltipPosition="above" matTooltipShowDelay="500">
                          <span class="material-icons f-18">check</span>
                        </button>
                      </ng-container>
                      <ng-template #tabTitleView>
                        <span class="tab-title-text text-truncate" [title]="tab.title">{{ tab.title }}</span>
                        <button type="button" (click)="startEditingTab(tab, $event)"
                          class="btn-empty border-0 p-0 ml-1 tab-action rounded-circle" [disabled]="isReadOnly"
                          matTooltip="Edit title" matTooltipPosition="above" matTooltipShowDelay="500">
                          <span class="material-icons f-18 w-22" style="margin-bottom:2px;">edit</span>
                        </button>
                      </ng-template>
                      <button *ngIf="tabs.length > 1 && !isReadOnly" type="button" (click)="removeTab(i, $event)"
                        class="btn-empty border-0 p-0 ml-1" [matTooltip]="'forms.builder.tabs.remove' | trans"
                        matTooltipPosition="above" matTooltipShowDelay="500">
                        <span class="material-icons f-18">close</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tab Content -->
              <div *ngIf="currentTab" class="mt-2">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="mb-0 font-weight-light lh-25">{{ currentTab.title }} - {{ 'forms.builder.fields.title' |
                    trans }}</h6>
                </div>

                <div class="fields-list" cdkDropList (cdkDropListDropped)="onFieldReordered($event)"
                  [cdkDropListDisabled]="isReadOnly">
                  <div *ngFor="let field of currentTab.fields; let i = index" class="card p-2 mb-2 bg-light field-item"
                    cdkDrag [cdkDragDisabled]="isReadOnly">

                    <div class="d-flex align-items-center mb-2">
                      <span *ngIf="!isReadOnly" class="material-icons drag-handle mr-2 cursor-move"
                        cdkDragHandle>drag_indicator</span>
                      <span class="badge badge-secondary mr-2">{{ getFieldTypeLabel(field.type) }}</span>
                      <span class="flex-grow-1"></span>
                      <button *ngIf="!isReadOnly" type="button" (click)="removeField(i)"
                        class="btn-empty opacity border-0 p-0" [matTooltip]="'forms.builder.fields.remove' | trans"
                        matTooltipPosition="above" matTooltipShowDelay="500">
                        <span class="material-icons f-18 icon-color-red">delete</span>
                      </button>
                    </div>

                    <div class="form-group mb-2">
                      <label class="font-weight-light f-15 mb-0 text-dark float-left">{{ 'forms.builder.fields.label' |
                        trans
                        }}</label>
                      <input type="text" [(ngModel)]="field.label" class="form-control h-35 mb-0"
                        placeholder="{{ 'forms.builder.fields.labelPlaceholder' | trans }}" [disabled]="isReadOnly" />
                    </div>

                    <div class="form-group mb-2">
                      <label class="font-weight-light f-15 mb-0 text-dark float-left">{{
                        'forms.builder.fields.helpText' | trans
                        }}</label>
                      <input type="text" [(ngModel)]="field.helpText" class="form-control h-35 mb-0"
                        placeholder="{{ 'forms.builder.fields.helpTextPlaceholder' | trans }}"
                        [disabled]="isReadOnly" />
                    </div>

                    <div class="form-group mb-2 pl-20x"
                      *ngIf="field.type !== 'description' && field.type !== 'image-display'">
                      <label class="font-weight-light f-15 mb-0 text-dark float-left">
                        <input type="checkbox" [(ngModel)]="field.required" [disabled]="isReadOnly"
                          class="form-check-input mr-1" />
                        {{ 'forms.builder.fields.required' | trans }}
                      </label>
                    </div>

                    <div class="form-group mb-2" *ngIf="field.type === 'text'">
                      <label class="font-weight-light f-15 mb-0 text-dark float-left">Input Type</label>
                      <select [(ngModel)]="field.inputType" class="form-control h-35 mb-0" [disabled]="isReadOnly">
                        <option *ngFor="let inputType of textInputTypes" [value]="inputType">
                          {{ getTextInputTypeLabel(inputType) }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group mb-2" *ngIf="field.type === 'text'">
                      <label class="font-weight-light f-15 mb-0 text-dark float-left">{{ 'forms.builder.fields.pattern'
                        | trans }}</label>
                      <input type="text" [(ngModel)]="field.pattern" class="form-control h-35 mb-0"
                        placeholder="{{ 'forms.builder.fields.patternPlaceholder' | trans }}" [disabled]="isReadOnly" />
                    </div>

                    <!-- Image configuration -->
                    <div *ngIf="field.type === 'image'" class="mt-2">
                      <label class="font-weight-light f-15 mb-2 text-dark float-left">Image Settings</label>

                      <div class="form-group mb-2">
                        <label class="font-weight-light f-13 mb-0 text-dark float-left">Aspect Ratio</label>
                        <select [(ngModel)]="field.imageConfig.aspectRatio" class="form-control h-35 mb-0"
                          [disabled]="isReadOnly">
                          <option value="free">Free (No constraint)</option>
                          <option value="1:1">Square (1:1)</option>
                          <option value="4:3">Standard (4:3)</option>
                          <option value="16:9">Widescreen (16:9)</option>
                          <option value="16:10">Monitor (16:10)</option>
                          <option value="4:1">Banner (4:1)</option>
                        </select>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <div class="form-group mb-2">
                            <label class="font-weight-light f-13 mb-0 text-dark float-left">Width (px)</label>
                            <input type="number" [(ngModel)]="field.imageConfig.imageWidth"
                              class="form-control h-35 mb-0" placeholder="400" [disabled]="isReadOnly" min="100"
                              max="2000" />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group mb-2">
                            <label class="font-weight-light f-13 mb-0 text-dark float-left">Height (px)</label>
                            <input type="number" [(ngModel)]="field.imageConfig.imageHeight"
                              class="form-control h-35 mb-0" placeholder="Optional" [disabled]="isReadOnly" min="100"
                              max="2000" />
                          </div>
                        </div>
                      </div>

                      <div class="form-group mb-2">
                        <label class="font-weight-light f-13 mb-0 text-dark float-left">Output Format</label>
                        <select [(ngModel)]="field.imageConfig.outputFormat" class="form-control h-35 mb-0"
                          [disabled]="isReadOnly">
                          <option value="png">PNG (Best quality, supports transparency)</option>
                          <option value="jpeg">JPEG (Compressed, smaller file size)</option>
                          <option value="webp">WebP (Modern format, good compression)</option>
                        </select>
                      </div>

                      <div class="form-group mb-2">
                        <label class="font-weight-light f-13 mb-0 text-dark float-left">Max File Size (MB)</label>
                        <input type="number" [ngModel]="getImageMaxFileSizeMB(field)"
                          (ngModelChange)="setImageMaxFileSizeMB(field, $event)" class="form-control h-35 mb-0"
                          placeholder="5" [disabled]="isReadOnly" min="1" max="10" step="0.5" />
                        <small class="form-text text-muted">Maximum size in megabytes (default: 5MB)</small>
                      </div>

                      <div class="form-group mb-2">
                        <div class="d-flex">
                          <label class="font-weight-light f-13 mb-0 text-dark ">Accepted File
                            Types</label>
                        </div>
                        <div class="d-flex pl-4 align-items-start flex-column">
                          <label class="font-weight-light f-13 mb-1 text-dark">
                            <input type="checkbox" class="form-check-input mr-1"
                              [checked]="isFileTypeAccepted(field, 'image/jpeg')"
                              (change)="toggleFileType(field, 'image/jpeg', $event)" [disabled]="isReadOnly" />
                            JPEG
                          </label>
                          <label class="font-weight-light f-13 mb-1 text-dark">
                            <input type="checkbox" class="form-check-input mr-1"
                              [checked]="isFileTypeAccepted(field, 'image/png')"
                              (change)="toggleFileType(field, 'image/png', $event)" [disabled]="isReadOnly" />
                            PNG
                          </label>
                          <label class="font-weight-light f-13 mb-1 text-dark">
                            <input type="checkbox" class="form-check-input mr-1"
                              [checked]="isFileTypeAccepted(field, 'image/gif')"
                              (change)="toggleFileType(field, 'image/gif', $event)" [disabled]="isReadOnly" />
                            GIF
                          </label>
                          <label class="font-weight-light f-13 mb-1 text-dark">
                            <input type="checkbox" class="form-check-input mr-1"
                              [checked]="isFileTypeAccepted(field, 'image/webp')"
                              (change)="toggleFileType(field, 'image/webp', $event)" [disabled]="isReadOnly" />
                            WebP
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Description field configuration -->
                    <div *ngIf="field.type === 'description'" class="mt-2">
                      <label class="font-weight-light f-15 mb-2 text-dark float-left">Description Content</label>
                      <quill-editor [modules]="quillModules" class="description-editor toolontop w-100 text-left"
                        [(ngModel)]="field.defaultValue" [disabled]="isReadOnly">
                      </quill-editor>
                      <small class="form-text text-muted">Format text with bold, italic, lists, and links to guide
                        users</small>
                    </div>

                    <!-- Image display field configuration -->
                    <div *ngIf="field.type === 'image-display'" class="mt-2">
                      <label class="font-weight-light f-15 mb-2 text-dark float-left">Image URL</label>
                      <input type="url" class="form-control h-35 mb-2" [(ngModel)]="field.defaultValue"
                        placeholder="https://example.com/image.png" [disabled]="isReadOnly" />
                      <small class="form-text text-muted">Enter image URL to display as guidance for users</small>
                      <img *ngIf="field.defaultValue" [src]="field.defaultValue" class="img-thumbnail mt-2"
                        style="max-height: 150px;" alt="Preview" />
                    </div>

                    <!-- Options for select fields -->
                    <div *ngIf="isSelectField(field.type)" class="mt-2">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <label class="font-weight-light f-15 mb-0 text-dark">{{ 'forms.builder.fields.options' | trans
                          }}</label>
                        <button *ngIf="!isReadOnly" type="button" (click)="addOption(i)" class="btn-empty border-0"
                          [matTooltip]="'forms.builder.fields.addOption' | trans" matTooltipPosition="above"
                          matTooltipShowDelay="500">
                          <span
                            class="material-icons portal-icon align-middle lh-25 center btn p-0 rounded-circle w-25 h-25 f-15">
                            add
                          </span>
                        </button>
                      </div>
                      <div *ngFor="let opt of field.options; let j = index" class="d-flex mb-1">
                        <input type="text" [(ngModel)]="opt.value" class="form-control form-control-sm mr-1"
                          placeholder="{{ 'forms.builder.fields.optionValue' | trans }}" [disabled]="isReadOnly" />
                        <input type="text" [(ngModel)]="opt.label" class="form-control form-control-sm mr-1"
                          placeholder="{{ 'forms.builder.fields.optionLabel' | trans }}" [disabled]="isReadOnly" />
                        <button *ngIf="!isReadOnly" type="button" (click)="removeOption(i, j)"
                          class="btn-empty border-0 p-0">
                          <span class="material-icons f-18 lh-30 icon-color-red">close</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Empty state -->
                  <div *ngIf="!currentTab.fields || currentTab.fields.length === 0"
                    class="text-center p-4 bg-light rounded">
                    <p class="mb-0 lh-25 font-weight-light">{{ 'forms.builder.fields.empty' | trans }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="row ml-0 mr-0">
          <div class="col-xl-10 col-lg-9 col-md-9 p-0 pr-2 mb-2 ml-auto">
            <div class="row ml-0 mr-0">
              <div class="col-sm-6 col-md-3 px-1">
                <button type="button" (click)="saveDraft()" class="btn-save"
                  [disabled]="isReadOnly || isPublishing || isArchiving">
                  <h6 class="btn-save-text lh-20 p-1">
                    {{ 'forms.builder.saveDraft' | trans }}
                  </h6>
                </button>
              </div>
              <div class="col-sm-6 col-md-3 px-1">
                <button type="button" (click)="publishForm()" class="btn-save"
                  [disabled]="!canPublish() || isArchiving">
                  <h6 class="btn-save-text lh-20 p-1">
                    {{ isPublishing ? ('forms.builder.publishing' | trans) : ('forms.builder.publish' | trans) }}
                  </h6>
                </button>
              </div>
              <div class="col-sm-6 col-md-3 px-1">
                <button type="button" (click)="archiveForm()" class="btn-close" [disabled]="!canArchive()">
                  <h6 class="btn-save-text lh-20 p-1">
                    {{ isArchiving ? ('forms.builder.archiving' | trans) : ('forms.builder.archive' | trans) }}
                  </h6>
                </button>
              </div>
              <div class="col-sm-6 col-md-3 px-1">
                <button type="button" (click)="discardChanges()" class="btn-close"
                  [disabled]="isReadOnly || isPublishing || isArchiving">
                  <h6 class="btn-save-text lh-20 p-1">
                    {{ 'forms.builder.discard' | trans }}
                  </h6>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Success/Error Alertbox -->
        <app-alertbox *ngIf="showsuccessarchive" [alerticon]="'check_circle'" [alerttype]="'success'"
          [alerttext]="'forms.successarchive' | trans">
        </app-alertbox>

        <app-alertbox *ngIf="showerrorarchive" [alerticon]="'error'" [alerttype]="'error'" [alerttext]="errorMessage">
        </app-alertbox>

        <app-alertbox *ngIf="showsuccessdraft" [alerticon]="'check_circle'" [alerttype]="'success'"
          [alerttext]="'forms.successdraft' | trans">
        </app-alertbox>

        <app-alertbox *ngIf="showerrordraft" [alerticon]="'error'" [alerttype]="'error'" [alerttext]="errorMessage">
        </app-alertbox>

        <app-alertbox *ngIf="showsuccesssave" [alerticon]="'check_circle'" [alerttype]="'success'"
          [alerttext]="'forms.successsave' | trans">
        </app-alertbox>

        <app-alertbox *ngIf="showwarningname" [alerticon]="'warning'" [alerttype]="'error'" [alerttext]="errorMessage">
        </app-alertbox>

        <!-- Confirmation Dialog -->
        <app-alertbox *ngIf="showconfirmarchive" [alerticon]="'warning'" [alerttype]="'confirm'"
          [alerttext]="'forms.confirmarchive.title' | trans" [confirmmessage]="'forms.confirmarchive.message' | trans"
          [confirmButtonText]="'forms.archive' | trans" [cancelButtonText]="'forms.cancel' | trans"
          (confirmed)="onArchiveConfirmed()" (cancelled)="onArchiveCancelled()">
        </app-alertbox>

        <app-alertbox *ngIf="showconfirmdraft" [alerticon]="'help'" [alerttype]="'confirm'"
          [alerttext]="'forms.confirmdraft.title' | trans" [confirmmessage]="'forms.confirmdraft.message' | trans"
          [confirmButtonText]="'forms.createdraft' | trans" [cancelButtonText]="'forms.cancel' | trans"
          (confirmed)="onDraftConfirmed()" (cancelled)="onDraftCancelled()">
        </app-alertbox>

        <app-alertbox *ngIf="showconfirmpublish" [alerticon]="'help'" [alerttype]="'confirm'"
          [alerttext]="'forms.confirmpublish.title' | trans" [confirmmessage]="'forms.confirmpublish.message' | trans"
          [confirmButtonText]="'forms.publish' | trans" [cancelButtonText]="'forms.cancel' | trans"
          (confirmed)="onPublishConfirmed()" (cancelled)="onPublishCancelled()">
        </app-alertbox>

      </div>
    </div>
  </div>
</div>